import { combineReducers } from 'redux';
import masterMappingReducer from './masterMappingReducer';
import detailsReducer from './detailsReducer';
import reportGroupReducer from './reportGroupReducer';
import reportFSNotesReducer from './reportFSNotesReducer';
import reportFSLinesReducer from './reportFSLinesReducer';
import reportAggregateReducer from './reportAggregateReducer';
import reportTestingSheetReducer from './reportTestingSheetReducer';
import reportCAPReducer from './reportCAPReducer';
import reportPAPReducer from './reportPAPReducer';

const rootReducer = combineReducers({
    masterMapping: masterMappingReducer,
    details: detailsReducer,
    reportGroup: reportGroupReducer,
    reportFSNotes: reportFSNotesReducer,
    reportFSLines: reportFSLinesReducer,
    reportAggregate: reportAggregateReducer,
    reportTestingSheet: reportTestingSheetReducer,
    reportCAP: reportCAPReducer,
    reportPAP: reportPAPReducer,
});

export default rootReducer;
